/* ===== Cafecam — scripts propios ===== */
(function () {
  var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.cc-reveal');
    if (!els.length) return;
    if (reducir || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cc-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria() {
    document.querySelectorAll('[data-cc-galeria]').forEach(function (g) {
      var principal = g.querySelector('[data-cc-principal]');
      if (!principal) return;
      g.querySelectorAll('[data-cc-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.src = btn.getAttribute('data-src');
          principal.removeAttribute('srcset');
          g.querySelectorAll('[data-cc-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });
    });
  }

  function initCompra() {
    document.querySelectorAll('[data-cc-compra]').forEach(function (cont) {
      var datos = cont.querySelector('[data-cc-variantes-json]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var input = cont.querySelector('input[name="id"]');
      var qtyInput = cont.querySelector('[data-cc-qty]');
      var precio = cont.querySelector('[data-cc-precio]');
      var antes = cont.querySelector('[data-cc-precio-antes]');
      var nombreColor = cont.querySelector('[data-cc-color-nombre]');
      var boton = cont.querySelector('[data-cc-boton]');
      var textoBoton = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';
      var descuento = parseInt(cont.getAttribute('data-descuento') || '0', 10);
      var formato = cont.getAttribute('data-formato') || '${{amount}}';
      var galeria = document.querySelector('[data-cc-principal]');
      var actual = variantes.find(function (x) { return String(x.id) === input.value; }) || variantes[0];

      function dinero(c) {
        var n = (Math.round(c) / 100).toFixed(2).replace(/\.00$/, '');
        n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
      }

      function pintarCantidades() {
        cont.querySelectorAll('[data-cc-cant-precio]').forEach(function (el) {
          var q = parseInt(el.getAttribute('data-cc-cant-precio'), 10) || 1;
          var base = actual.price * q;
          var final = q >= 2 ? base - descuento : base;
          el.firstChild.textContent = dinero(final);
          var ahorro = el.querySelector('small');
          if (ahorro) ahorro.textContent = q >= 2 && descuento > 0 ? (ahorro.getAttribute('data-texto') || 'Ahorras') + ' ' + dinero(descuento) : '';
        });
      }

      cont.querySelectorAll('input[data-cc-variante]').forEach(function (r) {
        r.addEventListener('change', function () {
          var v = variantes.find(function (x) { return String(x.id) === r.value; });
          if (!v) return;
          actual = v;
          input.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (antes) {
            if (v.compare_at_price && v.compare_at_price > v.price) { antes.textContent = dinero(v.compare_at_price); antes.hidden = false; }
            else { antes.hidden = true; }
          }
          if (nombreColor) nombreColor.textContent = v.title;
          if (boton) {
            boton.disabled = !v.available;
            boton.textContent = v.available ? textoBoton : textoAgotado;
          }
          if (galeria && v.img) { galeria.src = v.img; galeria.removeAttribute('srcset'); }
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
          pintarCantidades();
        });
      });

      cont.querySelectorAll('input[data-cc-cantidad]').forEach(function (r) {
        r.addEventListener('change', function () { if (qtyInput) qtyInput.value = r.value; });
      });
      pintarCantidades();
    });
  }

  function initBarraMovil() {
    var barra = document.querySelector('[data-cc-barra-movil]');
    var ancla = document.querySelector('[data-cc-boton]');
    if (!barra || !ancla || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      barra.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(ancla);
    var enlace = barra.querySelector('a');
    if (enlace) enlace.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('[data-cc-compra]').scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'start' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGaleria();
    initCompra();
    initBarraMovil();
  });
})();
